<template>
  <van-cell-group inset>
    <van-field
        v-html="license"
        rows="1"
        autosize
        type="textarea"
    />
  </van-cell-group>
</template>

<script>
export default {
  name: "UserService",
  data(){
    return{
      license:'&emsp;&emsp;欢迎您使用由青岛海鲲蓝宇科技有限公司运营的应用服务，为了切实保护用户的隐私权，优化用户体验，' +
          '本应用根据现行法律及政策，制定《用户服务协议》(以下简称“本协议”)。' +
          '本协议将详细说明本应用在协议变更与修改、用户账号生成、用户信息管理、软件更新、用户隐私保护等方面的保护政策及响应措施。\n <br/>' +
          '    一、定义\n<br/>' +
          '    1、本应用：在本协议中除非专门指明或声明，均指由青岛海鲲蓝宇科技有限公司所有并负责运营的应用软件，本应用只负责提供用户访问各个服务渠道，具体业务功能均由所属业务单位负责。\n<br/>' +
          '    2、用户/您：指同意并遵守本协议，完成本用于所有注册程序并经本应用确认，拥有本应用用户登陆账号和密码的自然人。\n<br/>' +
          '    3、用户信息：指包含用户注册信息，以及用户使用本应用服务时提交的、被本应用所知悉的交易信息。\n<br/>' +
          '    4、用户注册：是指用户登陆本应用，按要求填写相关信息并确认统一履行本协议的过程。\n<br/>' +
          '    5、用户注册信息：指用户在本应用注册的各项信息，包括其后通过身份验证后修改所填写的内容。\n<br/>' +
          '    6、用户指令：本协议中，除非专门指明或声明，均指用户以数据电子形式向本应用提出的申请、要求，包括但不限于用户要求本应用提供、变更或取消其依据本应用业务流程可享有的各项服务的申请、要求。\n<br/>' +
          '    7、用户服务：指本应用基于互联网方式向用户提供的服务。\n<br/>' +
          '    二、协议条款的确认和接受\n<br/>' +
          '    1、本应用在此特别提醒您，在您使用注册前请仔细阅读本协议，如果您对本协议的任何条款或将来随时可能修改、补充的条款有异议，您可选择不注册成为本应用的用户。\n<br/>' +
          '    2、当您点选“同意”按钮时即视为您已仔细阅读本协议条款，同意接受本协议条款的所有规范包括接受本应用对本协议条款随时所做的任何修改、并愿受其约束。\n<br/>' +
          '    3、本应用有权在必要时修改本协议条款，协议条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动注销其用户账号。如果用户继续使用本应用所提供的用户服务，则视为接受本协议条款的变动。\n<br/>' +
          '    4、本应用保留在任何时候自行决定对本应用及其相关功能的变更、升级、修改、转移的权利。本应用进一步保留在本应用中开发新的功能或其他语种服务的权利。上述所有新的功能、软件服务的提供，除非本应用另有说明，否则仍适用本协议。\n<br/>' +
          '    三、用户账号\n<br/>' +
          '1、账号注册：用户在注册账号时，应当按注册页面引导提供真实、准确、最新和完善的信息资料。针对个人用户，包含但不限于使用本人手机短信、身份证、人脸识别等个人信息进行实名验证。如果用户提供的注册信息不合法、不真实、不准确的，用户需承担因此引起的相应责任及后果。本应用有权对用户注册信息的合法性、真实性和有效性进行审核，并将用户提供的注册信息与法律法规允许的机构或政府机关授权的机构进行实名验证。用户阅读并同意本协议且完成全部注册程序后，即可获得本应用账号并成为本应用用户。\n<br/>' +
          '2、账号管理：用户的账号所有权归本应用所有，用户完成申请注册手续后，仅获得账号的使用权。且该使用权仅属于申请注册人（即用户）。用户应当对以其用户名登陆进行的所有活动和事件负法律责任。同时，用户不得赠与、转让、出借或者以其他方式许可他人使用该账号。否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。\n<br/>' +
          '3、用户有义务保障账号和密码的安全。如用户发现账号遭到未经授权的使用或发生其他任何安全问题时，用户应立即通知本应用。因黑客行为、系统安全或用户的保管疏忽导致账号非法使用，本应用不承担任何责任。\n<br/>' +
          '4、用户丢失或遗忘密码后通过手机号码重置密码时，本应用只负责核对验证信息是否与账号相关信息一致，不对冒名验证行为及其造成的损失承担责任。\n<br/>' +
          '5、如用户注销账号或被终止使用本应用及服务，本应用可以从服务器上永久地删除该用户的数据；服务终止或取消后，本应用没有义务向用户返还或恢复任何数据。\n<br/>' +
          '四、服务内容\n<br/>' +
          '本应用将按照本协议及相关操作规程为用户提供相应的用户服务，针对个人用户，主要内容提供相关健康管理问卷测评服务。\n<br/>' +
          '五、使用注意事项\n<br/>' +
          '1、用户保证自己再注册时用户身份的真实性和正确性及完整性，如果资料发生变化，用户应及时更改，本应用不能也不会对您的资料不真实、不准确，或您的资料未能及时更新，或因您丢失了身份证号码和密码而引起的任何损失或损害承担责任。若用户提供任何错误、不实，过时或不完整的资料，或者本应用有合理理由怀疑前述资料为错误、不实、过时或不完整，本应用有权暂停或终止用户的账号。\n<br/>' +
          '2、用户登陆账号及密码为用户在本应用的唯一身份权证，为使用本应用提供的用户服务，您须按照对应的服务要求键入正确的登陆账号和密码。如果用户发现自己的个人信息泄露，尤其是本应用账号及密码发生泄露，请用户立即联络本应用。\n<br/>' +
          '3、用户使用本应用及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于账号头像、名字、用户说明等注册信息，或文字、图片等发送、回复、随手拍图文和相关链接页面，以及其他使用账号或本应用及服务所产生的内容，不得侵犯其他用户或第三方合法权益，否则本应用有权拒绝提供服务，且用户应承担所有相关法律责任。上述行为包括但不限于：发布、传播、储存违反国家法律法规禁止的内容：\n<br/>' +
          '（1）违反宪法确定的基本原则的；\n<br/>' +
          '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；\n<br/>' +
          '（3）损害国家荣誉和利益的；\n<br/>' +
          '（4）煽动民族仇恨、民族歧视、破坏民族团结的；\n<br/>' +
          '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；\n<br/>' +
          '（6）散布谣言，扰乱社会秩序，破坏社会稳定的；\n<br/>' +
          '（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；\n<br/>' +
          '（8）侮辱或者诽谤他人，侵害他人合法权益的；\n<br/>' +
          '（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；\n<br/>' +
          '（10）以非法民间组织名义活动的；\n<br/>' +
          '（11）不符合《即时通讯工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；\n<br/>' +
          '（12）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；\n<br/>' +
          '（13）涉及他人隐私、个人信息或资料的；\n<br/>' +
          '（14）发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；\n<br/>' +
          '（15）其他违反法律法规、政策及公序良俗、社会公德或干扰本应用正常运营或侵犯其他用户或第三方合法权益内容的信息。\n<br/>' +
          '4、本应用发现用户在使用本应用服务过程中有违反法律规定或本协议约定的，有权不经通知，单方终止或解除本协议，暂停、中断或终止向用户提供服务并追究用户的法律责任。\n<br/>' +
          '除非法律允许或青岛海鲲蓝宇科技有限公司书面许可，用户使用本应用过程中不得从事下列行为：\n<br/>' +
          '（1）删除本应用及其副本上关于著作权的信息；\n<br/>' +
          '（2）对本应用进行反向工程、反向汇编、反向编译，或者以其他尝试发现本应用的源代码；\n<br/>' +
          '（3）对青岛海鲲蓝宇科技有限公司拥有的知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；\n<br/>' +
          '（4）对本应用或者本应用运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本应用运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非本应用授权的第三方工具、服务接入本应用和相关系统；\n<br/>' +
          '（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；\n<br/>' +
          '（6）自行或者授权他人、第三方软件对本应用及其组件、模块、数据进行干扰。\n<br/>' +
          '5、用户在使用本应用账号时承诺并确认：\n<br/>' +
          '（1）用户同意接收本应用推送的消息；\n<br/>' +
          '（2）用户上传到本应用的除个人信息以外的文字、图片和音频等内容，本应用具有免费使用权；\n<br/>' +
          '（3）本应用提供的网络服务内容可能包括：文字、软件、图片、视频、图表等。所有这些内容受版权、商标和其他财产所有权法律的保护，用户只是在获得本应用或其他相关权利人的授权之后才能使用这些内容。\n<br/>' +
          '6、用户在使用本应用的过程中与其他用户发生纠纷的，双方自行解决。用户如发现其他用户有违法或违反本协议的行为，可以向本应用举报。\n<br/>' +
          '  7、用户自行承担因交易产生的相关税、费。\n<br/>' +
          '六、软件更新\n<br/>' +
          '    1、青岛海鲲蓝宇科技有限公司负责本应用系统的日常运营和维护。为了提升用户体验、完善业务功能和服务内容，本应用有权根据业务发展需要采用包括但不限于软件修改、替换、功能优化、版本升级等形式，对本应用进行更新升级或对本应用服务功能、内容等进行调整。\n<br/>' +
          '2、本应用根据系统升级、改造需要，有权修改软件功能、暂停中止提供本应用服务的权利，但应尽可能事先进行告知。因行使上述修改或中止软件使用而造成的任何损失，用户同意本应用不需对用户或任何第三方负责。\n<br/>' +
          '3、本应用新版本发布后，不保证旧版本应用及提供相应用户服务的继续可用，请用户及时备份数据、及时核对并下载最新版本。\n<br/>' +
          '七、服务变更、中断或终止\n<br/>' +
          '1、若因系统维护或升级的需要而需暂停网络服务，本应用将尽可能事先进行通告。\n<br/>' +
          '2、本协议的终止，意味您在本应用的服务即终止。即日起，本应用将不保留您登陆账号中的任何内容，不负责将未阅读或未发出之信息传送给用户或第三方。\n<br/>' +
          ' 3、本协议的终止并不能被认为免除用户在本协议生效期间应履行的相关付款义务。\n<br/>' +
          ' 4、本协议的终止并不意味着终止前所发生的未完成用户指令的撤销，也不能消除因终止前的交易所带来的法律后果。\n<br/>' +
          '八、知识产权声明\n<br/>' +
          '1、青岛海鲲蓝宇科技有限公司是本应用的知识产权权利人。本应用的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本应用相关的所有信息内容（包括不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。\n<br/>' +
          '  2、未经本应用或相关权利人书面同意，用户不得自行或许可任何第三方实施、利用、转让上述知识产权。\n<br/>' +
          '九、责任声明\n<br/>' +
          '  1、 本应用不就通信系统或互联网的中断或无法运作、技术故障、计算机错误或病毒、信息损坏或丢失或其他在本应用合理控制范围之外的原因而产生的其他任何性质的破坏而向用户或任何第三方承担赔偿责任。\n<br/>' +
          '  2、青岛海鲲蓝宇科技有限公司不保证用户在使用本应用时在操作上不会中断或没有错误，不保证会纠正本应用所有缺陷，亦不保证本应用能满足用户的所有要求。\n<br/>' +
          '3、本应用不担保其所提供的网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。\n<br/>' +
          '4、用户明确同意其使用本应用网络服务所存在的风险将完全由其自己承担；因其使用本网络服务而产生的一切后果也由其自己承担，青岛海鲲蓝宇科技有限公司或本应用对用户不承担任何责任。\n<br/>' +
          '5、用户在此同意青岛海鲲蓝宇科技有限公司在任何情况下都无需向用户或任何第三方在使用本应用时对其在传播或联络中的延迟、不准确、错误或疏漏及因此而致使的损害负责。\n<br/>' +
          '十、不可抗力\n<br/>' +
          '因不可抗力、黑客攻击、病毒、木马、恶意程序攻击、网络拥堵、通讯故障、电力故障、银行原因、第三方服务瑕疵等原因而导致的用户信息泄露、服务中断及其他损失，本应用不承担任何损害赔偿责任。\n<br/>' +
          '十一、法律及争议解决\n<br/>' +
          '1、本协议适用中华人民共和国法律。如遇本协议有关的某一特定事项缺乏明确法律规定，则应参照通用国际商业惯例或行业惯例。\n<br/>' +
          '2、 如双方就本协议内容或执行发生任何争议、双方应协商解决；协商不成时，应向青岛海鲲蓝宇科技有限公司所在地人民法院提起诉讼解决。\n<br/>' +
          '十二、协议的转让\n<br/>' +
          '除非事先取得本应用书面同意，用户不得将其在本协议项下的权利与义务转让给任何第三方。\n<br/>' +
          '十三、其他规定\n<br/>' +
          '1、本协议构成用户和青岛海鲲蓝宇科技有限公司间就使用本应用的完整的协议，并取代双方就有关本协议所载任何事项于先前以口头及书面达成的共识。\n<br/>' +
          '2、 如本协议的任何条款被视作无效或无法执行，则 上述条款可被分离，其余部分则仍具有法律效力。\n<br/>' +
          '3、 本协议的标题仅为方便阅读所设，非对条款的定义、限制、解释或描述其范围或界限。\n<br/>' +
          '4、 本应用于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类只过失或违约行为弃权。'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/user/UserService.vue